import styled from "styled-components";

const FooterContainer = styled.div`
  z-index: 3;
  background-color: #fff;
  left: 0px;
  bottom: 0px;
  border-top: 1px solid rgb(33, 175, 196);
  width: 100%;
  .Banner {
    width: 50%;
    margin: 0 auto;
  }
  .BannerImg {
    ul {
      list-style: none;
      padding: 0;
      display: flex;
      margin: 0;
      margin: 0.9em 0;
      li {
        width: auto;
        margin: auto;
        img {
          height: 35px;
          vertical-align: bottom;
        }
      }
    }
  }
  .BannerImg img {
    margin: 0 auto;
  }
  .Content {
    display: flex;
    justify-content: center;
    width: 50%;
    margin: 0 auto;
    margin-bottom: 0.5%;
  }
  .ContentImg {
    margin-top: 1.5%;
    vertical-align: middle;
    width: 30%;
    height: 50%;
    img {
      width: 80%;
      height: 100%;
    }
  }
  .ContentAddress {
    font-size: 1rem;
    margin-right: auto;
    text-align: left;
    color: #666;
    p {
      margin: 0;
    }
    span {
      padding-left: 5%;
    }
  }
  td {
    text-align: left;
  }
  @media only screen and (max-width: 480px) {
    position: static;
    .Banner {
      margin: 0;
      width: 100%;
      padding: 0;
    }
    .BannerImg {
      width: 100%;
      img {
        width: 35%;
      }
    }
    .Content {
      width: 100%;
      margin: 0;
      display: block;
    }
    .ContentImg {
      margin: 0 auto;
      width: 80%;
      height: auto;
    }
    .ContentAddress {
      margin: 0;
      span {
        width: auto;
        margin-right: auto;
        p {
          margin: auto;
        }
      }
      b {
        width: 25%;
        text-align: right;
      }
      td {
        width: auto;
        word-break: keep-all;
        display: flex;
        justify-content: center;
      }
    }
  }
`;

export default FooterContainer;
